import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton, Grid, Box } from '@mui/material';
import { PageContainer, ExportButton, TableComponents, FilterPod, Icons } from 'components';
import { enifyDateTime } from 'utility';
import { useExportFile , useCurrencyUnit} from 'hooks';
import { toFilterVOS } from 'components/FilterPod';
import { columns } from './components/columns';
import InitFilters from './constants/InitFiltering';
import DialogServiceCall from './components/DialogServiceCall';
import ServiceCallServices from '../ServiceCall/services/ServiceCallServices';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import { getExport1463Url } from 'URLs';
const MyServiceCall = () => {
  // -- STATES --//
  const currencyText = useCurrencyUnit();
  const [filters, setFilters] = useState(InitFilters(currencyText));
  const [filterParams, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const [isloadingPage, setIsloadingPage] = useState(false);
  const [currentServiceSetId, setCurrentServiceSetId] = React.useState(null);
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);
  const actionsList =
    getDynamicObjectAction([
      'callsWebServiceListPage',
      'exportCallsWebServiceListBtn',

    ])
  // -- HOOKS --//
  const { downloadFile, isExporting } = useExportFile({
    url: getExport1463Url(),
    filename: 'my-service-call',
  });
  const navigate = useNavigate();
  const tableRef = useRef();
  // change format date
  const changeDateFormat = (date) => {
    let arr = date.split('/');
    return `${arr?.[0]}${arr?.[1]}${arr?.[2]}`;
  };
  // -- API REQUESTS --//
  const getMyserviceCallQuery = async (query) => {
    setIsloadingPage(true);
    const filter = toFilterVOS(filters);
    let orderBy = [];

    if (query?.orderBy) {
      const desc = query?.orderDirection === 'desc';

      switch (query?.orderBy?.title) {
        case 'تاریخ و زمان فراخوانی':
          orderBy = [
            { name: 'تاریخ فراخوانی', desc },
            { name: 'زمان فراخوانی', desc },
          ];
          break;
        case `قیمت (${currencyText})`:
          orderBy = [{ name: 'قیمت', desc }];
          break;
        default:
          orderBy = [{ name: query?.orderBy?.title, desc }];
          break;
      }
    }

    const params = {
      page: query ? query?.pageNumber : page,
      size: query?.pageSize || size,
    };
    const postBodyParams = {
      filterVOS: filter ?? [],
      orderByElementVOS: orderBy ?? [],
      parentParams: [
        { key: 'businessid', value: '774' },
        {
          key: 'START_DATE',
          value: changeDateFormat(enifyDateTime(filters[0]?.value?.start?.format('jYYYY/jMM/jDD'))),
        },
        {
          key: 'END_DATE',
          value: changeDateFormat(enifyDateTime(filters[0]?.value?.end?.format('jYYYY/jMM/jDD'))),
        },
      ],
    };

    setFilterParams({ postBodyParams, params });

    try {
      const res = await ServiceCallServices.reportMyServiceCall(params, postBodyParams);
      const data = res.data.result.rows.map((row, key) => ({
        // num: query?.page * query?.pageSize + key + 1,
        serviceId: row.cols[6],
        serviceName: row.cols[0],
        calledDate: row.cols[1],
        calledTime: row.cols[2],
        status: row.cols[3] === 'false' ? 'ناموفق' : 'موفق',
        serviceReceiver: row.cols[4],
        price: row.cols[5] != null ? row.cols[5] : '-',
        serviceSet: (
          <IconButton onClick={() => handleOpenDialog(row.cols[6])} size="large">
            <Icons icon="productList" color="#667585" size="20" />
          </IconButton>
        ), // شناسه سرویس => مجموعه سرویس
        factorId: row.cols[7] || '-',
      }));
      setIsloadingPage(false);
      return {
        data,
        page: query ? query?.pageNumber : page,
        totalCount: res.data.result.totalCount,
      };
    } catch (error) {

      if (axios.isCancel(error)) {
        setIsloadingPage(true);
      } else {
        setIsloadingPage(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.postBodyParams, filterParams?.params);
  };

  const handleOpenDialog = (serviceSetId) => {
    setCurrentServiceSetId(serviceSetId);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const hint =
    'در این صفحه می‌توانید گزارش سرویس‌هایی که مشتریان شما فراخوانی کرده‌اند را مشاهده نمایید.';

  return (
    <>
      <PageContainer
        title="لیست فراخوانی سرویس‌های من"
        pageKey="myServiceCalls"
        breadcrumbs={constBreadCrumbsTitle.SERVICES_MYSERVICECALLS}
        description={hint}
      >
        <Grid item xs={12}>
          <Box display="flex" justifyContent='end' alignItems="flex-end" style={{ marginBottom: 16 }}>
            {actionsList['callsWebServiceListPage'] && (
              <FilterButton
                setOpenFilterDialog={setOpenFilterDialog}
                filters={filters}
              />
            )}
            {actionsList['exportCallsWebServiceListBtn'] && (
              <ExportButton
                loading={isExporting}
                types={['xls', 'csv']}
                onExport={onExport}
              />
            )}
          </Box>
          {actionsList['callsWebServiceListPage'] && (

            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          )}
        </Grid>
        {actionsList['callsWebServiceListPage'] && currencyText && (
          <TableComponents
            data={getMyserviceCallQuery}
            columns={columns(handleOpenDialog, navigate , currencyText)}
            ref={tableRef}
            isLoading={isloadingPage}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getMyserviceCallQuery(ps)
            }}
          />

        )}
        <DialogServiceCall
          open={openDialog}
          onClose={handleCloseDialog}
          serviceSetId={currentServiceSetId}
        />
      </PageContainer>
    </>
  );
};

export default MyServiceCall;
